import { LangTranslate } from "../../types/types";

export type UpdateTranslationsRequest = {
   key:string,
   translationsList:LangTranslate[],
   site:string;
   isAdmin:string
  };
export function createUpdateTranslationsRequest(
  key: string,
  translationsList: LangTranslate[],
    isAdmin:string,
  site: string = "client",
  
): UpdateTranslationsRequest {
  return { key, translationsList, site ,isAdmin};
}